/* eslint-disable no-unused-vars */
import * as S from './RoundBtn.styled';
import { DropDownArrowUp, DropDownArrowDown } from 'assets/icons';
import { Link } from 'react-router-dom';

const RoundBtn = ({ toggling, isOpen, values, dropdownHeader = '', onOptionClicked }) => {
  const initials = dropdownHeader?.charAt(0)?.toUpperCase();

  return (
    <S.DropDownContainer onClick={toggling}>
      <S.Wrap>
        <S.DropDownHeader isOpen={isOpen}>{initials}</S.DropDownHeader>
        {isOpen ? <DropDownArrowDown /> : <DropDownArrowUp />}
      </S.Wrap>
      <S.DropDownListContainer isOpen={isOpen}>
        <S.DropDownList>
          {values &&
            values?.map((item) => {
              if (item.key === 'logout') {
                return (
                  <S.ListItem key={item.key || item} onClick={() => onOptionClicked(item)}>
                    <span>{item.icon}</span>
                    <span> {item.value || item}</span>
                  </S.ListItem>
                );
              }
              return (
                <S.ListItem key={item.key || item}>
                  <Link
                    to={item.href}
                    style={{ textDecoration: 'none', color: 'inherit', cursor: 'inherit' }}
                  >
                    <span>{item.icon}</span>
                    <span> {item.value || item}</span>
                  </Link>
                </S.ListItem>
              );
            })}
        </S.DropDownList>
      </S.DropDownListContainer>
    </S.DropDownContainer>
  );
};

export default RoundBtn;
